export const PurchaseOrderStatus = {
  Draft: 'Draft',
  Ordered: 'Ordered',
  Received: 'Received',
  Canceled: 'Canceled',
} as const;

export type PurchaseOrderStatusType = (typeof PurchaseOrderStatus)[keyof typeof PurchaseOrderStatus];

export class PurchaseOrder {
  id!: string;
  tenantId!: number;
  partName!: string;
  partNumber!: string | null;
  reference!: string | null;
  quantity!: number;
  registrationNumber!: string | null;
  vin!: string | null;
  buildReference!: string | null;
  masterBuildId!: string | null;
  orderId!: string | null;
  orderReference!: string | null;
  inventoryId!: string | null;
  inventoryItemName!: string | null;
  supplierId!: string | null;
  supplierName!: string | null;
  status!: string;
  receivedQuantity!: number | null;
  costPrice!: number | null;
  receivedDate!: string | null;
  creationTime!: string;
}

export class CreatePurchaseOrder {
  partName!: string;
  partNumber?: string;
  reference?: string;
  quantity!: number;
  registrationNumber?: string;
  vin?: string;
  buildReference?: string;
  orderId?: string;
  masterBuildId?: string;
  inventoryId?: string;
  supplierId?: string;
}

export class UpdatePurchaseOrder {
  id!: string;
  partName!: string;
  partNumber?: string;
  reference?: string;
  quantity!: number;
  registrationNumber?: string;
  vin?: string;
  buildReference?: string;
  supplierId?: string;
  inventoryId?: string;
}

export class GetAllPurchaseOrdersInput {
  search?: string;
  status?: string;
  supplierId?: string;
  orderId?: string;
  sorting?: string;
  skipCount: number = 0;
  maxResultCount: number = 15;
}

export class ReceivePurchaseOrder {
  id!: string;
  receivedQuantity!: number;
  costPrice?: number;
}

// AI invoice receive DTOs
export interface ParsedInvoiceLineItem {
  name: string;
  partNumber: string | null;
  quantity: number | null;
  unitPrice: number | null;
  totalPrice: number | null;
  category: string | null;
}

export interface ParsedInvoice {
  supplierName: string;
  supplierEmail: string;
  supplierPhone: string;
  supplierAddress: string;
  invoiceNumber: string;
  invoiceDate: string | null;
  totalAmount: number | null;
  lineItems: ParsedInvoiceLineItem[];
}

export type PurchaseOrderMatchStatus = 'Matched' | 'NoMatch' | 'MultipleCandidates';

export interface PurchaseOrderMatchResult {
  parsedLine: ParsedInvoiceLineItem;
  candidates: PurchaseOrder[];
  bestMatch: PurchaseOrder | null;
  matchStatus: PurchaseOrderMatchStatus;
  suggestedReceivedQty: number | null;
}

export interface BulkReceiveLine {
  purchaseOrderId: string;
  receivedQuantity: number;
  costPrice?: number;
}

export interface BulkReceivePurchaseOrder {
  documentId?: string;
  supplierInvoiceNumber?: string;
  supplierId: string;
  lines: BulkReceiveLine[];
}
